<template>
    <div>
        <div class="nav bg-biru pl20 pr20 pt10 pb10">
            <div class="box-horizontal">
                <div class="" @click="met.back()">
                    <img src="@/assets/back.png" alt="" style="height:30px">
                </div>
                <div class="flex-1 f13 text-center white">
                    
                </div>
                <div class=""></div>
            </div>
        </div>
        <div class="text-center pb20 bg-biru">
            <img src="@/assets/router-putih.png" alt="" style="height:60px">
            <span class="block white">Modemku</span>
        </div>
        <div class="wrapper">
            <div class="body">
                <div class="device mt10 p10 white-box-header">
                    <span class="block mb10">Info Modem :</span>
                    <div class="box-horizontal">
                        <div class="flex-1">
                            <span class="block f10 biru">Pppoe</span>
                            <span class="block hitam f15">{{get.data.ppoe}}</span>
                        </div>
                        <div class="flex-1">
                            <span class="block f10 biru">Model Modem</span>
                            <span class="block hitam f15">{{get.data.modem}}</span>
                        </div>
                    </div>
                    <div class="box-horizontal" v-show="false">
                        <div class="flex-1">
                            <span class="block f10 biru">SN modem</span>
                            <span class="block hitam f15">{{get.data.sn_modem}}</span>
                        </div>
                        <div class="flex-1">
                            <span class="block f10 biru">Redaman</span>
                            <span class="block hitam f15">{{get.data.redaman}}</span>
                        </div>
                    </div>
                </div>
                <div class="device mt10 p10 white-box-header text-center" v-show="!get.data.isAcs"> <!-- default : false -->
                    Provider tidak pakai Sistem Monitor Modem :)
                </div>
                <div class="device mt10 p10 white-box-header" v-show="get.data.isAcs">
                    <span class="block mb10" >Daftar Wifi :</span>
                    <div class="tulang mb20" v-show="get.data.loading">
                        <Loading style="height: 30px;" class="mb10">
                        </Loading>
                        <Loading style="height: 30px;">
                        </Loading>
                    </div>
                    <div class="mb20" v-show="!get.data.loading">
                        <div class="pt10 pb10 bt-1" v-for="(u, index) in get.data.WifiList" @click="get.getDevice(u)">
                            <span class="blue block">{{ u.nama }}</span>
                            <small  class="gray">password : {{ u.password }}{{ u.password }}</small>
                        </div>
                    </div>
                    
                    <div v-show="get.data.deviceBox">
                        <span class="block mb10">Daftar Device :</span>
                        <div class="tulang" v-show="get.data.loadingDevice">
                            <Loading style="height: 30px;" class="mb10">
                            </Loading>
                            <Loading style="height: 30px;">
                            </Loading>
                        </div>
                        <div class="mb20" v-show="!get.data.loadingDevice">
                            <div class="pt10 pb10 bt-1" v-for="(u, index) in get.data.DeviceList" v-show="get.data.DeviceList.length != 0">
                                <span v-if="u.nama != '' && u.nama != null">{{ u.nama }}</span>
                                <span v-else>Laptop/komputer (mungkin hehe)</span>
                            </div>
                            <span class="pt10 pb10 gray" v-show="get.data.DeviceList.length == 0">Tidak ada Device</span>
                        </div>
                    </div>
                    <div v-show="false"> <!-- get.data.deviceBox && get.data.sistemAcs == 'mandiri' -->
                        <span class="block mb10 gray">Setting Device :</span>
                        <div class="pt10 pb10 bt-1 blue" @click="get.data.gantiBox = true,get.data.gantiBuat = 'nama'">
                            <span>Ganti Nama Wifi</span>
                        </div>
                        <div class="pt10 pb10 bt-1 blue" @click="get.data.gantiBox = true,get.data.gantiBuat = 'pass'">
                            <span>Ganti Password</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="popup-box" v-show="get.data.gantiBox"> <!-- get.data.gantiBox -->
            <div class="popup-inner">
                <span class="block mb20" v-if="get.data.gantiBuat == 'nama'">Ganti Nama Wifi</span>
                <span class="block mb20" v-else>Ganti Password Wifi</span>
                <input type="text" class="block p10 w100 bt-1 f15 mb20" placeholder="Ketik disini..." v-model="get.data.gantiInput">
                
                <button class="btn btn-info btn-sm" @click="get.updateDevice()">Simpan</button>
                <button class="btn btn-gray btn-sm" @click="get.data.gantiBox = false">Batal</button>
            </div>
        </div>
    </div>
</template>

<script>
import myGlobal from '@/MyGlobal'
import { reactive } from '@vue/composition-api'
import store from '@/store/index'
import inter from '@/Interface'
import router from '@/router'
import Loading from '@/global/Loading' 

export default {
    components: { 
        'Loading': Loading
    },
    setup() {
        const get = {
            data: reactive({
                this: '',
                ppoe: null,
                modem: null,
                sn_modem: null,
                loading: true,
                loadingDevice: true,
                isAcs: false,
                sistemAcs: null,
                acsip: null,
                acsppoe: null,
                redaman: "-",
                deviceID: null,
                acsList: [],
                WifiList: [],

                deviceBox: false,
                DeviceList: [],

                gantiNoDevice: null,
                gantiBox: false,
                gantiBuat: null, // nama / pass
                gantiInput: "",

                LoopCount: 0
            }),
            list() {
                var datax = {
                    token: 'TangTung ' //+sessionStorage.getItem('Token')
                };
            
                var apiUrl = inter.KategoriList();

                myGlobal.call(datax,apiUrl).then(x => {
                    //console.log(JSON.stringify(x));
                    //data.loading = false;
                    if (x.status == true) {
                        mainData.data = x.data;
                        //theGet.data.Total = x.pesan;
                    } else {
                        
                    }
                })
            },
            getInfo() {
                var datax = {
                    token: 'TangTung ' +sessionStorage.getItem('tokenu'),
                };
            
                var apiUrl = inter.getInfoModem();

                myGlobal.call(datax,apiUrl).then(x => {

                    //data.loading = false;

                    if (x.status == true) {

                        get.data.ppoe = x.data.ppoe;
                        get.data.modem = x.data.modem;
                        get.data.sn_modem = x.data.sn_modem;
                        get.data.isAcs = x.data.isAcs;

                        get.data.acsip = x.data.acsip;
                        get.data.acsppoe = x.data.acsppoe;
                        
                        let sistemAcse = x.data.sistemAcs;
                        
                        get.data.sistemAcs = sistemAcse;

                        if(sistemAcse == "mandiri") {

                            get.data.acsList = x.data.listacs;

                            //console.log(JSON.stringify(get.data.acsList));

                            get.getIndexACSLoop();
                            
                        } else {
                            get.getIndexACS(null, null);
                        }
                        

                        // console.log(get.data.acsip);

                        // mainData.data = x.data;
                        // theGet.data.Total = x.pesan;


                    } else {
                        
                    }
                })
            },
            getIndexACSLoop() {

                let ACSList = get.data.acsList.length;

                //console.log(ACSList);

                if(get.data.LoopCount < ACSList) {
                    get.getIndexACS("ya", get.data.LoopCount);

                    get.data.LoopCount = get.data.LoopCount + 1;
                }

            },
            getIndexACS(isLoop,count) {
                //console.log(get.data.acsList[count].nama);

                if(isLoop == null) {

                    var datax = {
                        virtualppoe: get.data.acsppoe,
                        ppoe: get.data.ppoe,
                        sn: get.data.sn_modem,
                        ipen: get.data.acsip
                        //token: 'TangTung ' +sessionStorage.getItem('tokenu'),
                    };

                } else {
                    
                    var datax = {
                        virtualppoe: get.data.acsList[count].ppoe,
                        ppoe: get.data.ppoe,
                        sn: get.data.sn_modem,
                        ipen: get.data.acsList[count].ip
                        //token: 'TangTung ' +sessionStorage.getItem('tokenu'),
                    };

                }

                // console.log(JSON.stringify(datax));

                /*

{"status":true,"data":{"id":"00259E-HG8245H5-48575443DDF9229E","product_class":"HG8245H5","ppoe":"server-tp","redaman":"-13 dBm","statusRedaman":"kuat","lastPing":"2025-03-19 09:27:57","status":"Online","lastRestart":"2025-03-18 23:07:52","ssid":"Bill's","sn":"48575443DDF9229E"},"pesan":"ok"}

                */
               
                // console.log(JSON.stringify(datax));
            
                var apiUrl = inter.getIndexAcs();

                myGlobal.callAcs(datax,apiUrl).then(x => {
                    //console.log("halo "+JSON.stringify(x));

                    //data.loading = false;

                    if (x.status == true) {

                        get.data.redaman = x.data.redaman;
                        get.data.deviceID = x.data.id;

                        if(isLoop == "ya") {
                            get.data.acsip = get.data.acsList[count].ip;
                        }

                        get.getWifi();

                    } else {
                        
                        //console.log(JSON.stringify(isLoop));

                        if(isLoop == "ya") {

                            //console.log("Loop Ulang "+count);

                            get.getIndexACSLoop();

                        }

                    }
                })
            },
            getWifi() {
                console.log("get wifi");

                var datax = {
                    id: get.data.deviceID,
                    ipen: get.data.acsip
                };
            
                var apiUrl = inter.getListWifi();

                myGlobal.callAcs(datax,apiUrl).then(x => {
                    //console.log(JSON.stringify(x));
                    
                    get.data.loading = false;

                    if (x.status == true) {

                        get.data.WifiList = x.data;

                        // mainData.data = x.data;
                        // theGet.data.Total = x.pesan;

                    } else {
                    }
                })
            },
            getDevice(data) {

                get.data.deviceBox = true;


                get.data.gantiNoDevice = data.no;

                var datax = {
                    id: get.data.deviceID,
                    ipen: get.data.acsip,
                    no: data.no
                };
            
                var apiUrl = inter.getListDevice();

                myGlobal.callAcs(datax,apiUrl).then(x => {
                    //console.log(JSON.stringify(x));
                    
                    get.data.loadingDevice = false;

                    if (x.status == true) {

                        get.data.DeviceList = x.data;

                        // mainData.data = x.data;
                        // theGet.data.Total = x.pesan;

                    } else {
                        get.data.DeviceList = [];
                        
                    }
                })
            },
            updateDevice() {
                
                if(get.data.gantiInput == "") {
                    alert("Input tidak boleh kosong");
                    return false;
                }

                var datax = {
                    id: get.data.deviceID,
                    ipen: get.data.acsip,
                    no: get.data.gantiNoDevice,
                    state: get.data.gantiBuat, // nama / pass
                    val: get.data.gantiInput,
                };

                console.log(JSON.stringify(datax));

                return false;
            
                var apiUrl = inter.updateDevice();

                myGlobal.callAcs(datax,apiUrl).then(x => {
                    // console.log(JSON.stringify(x));
                    
                    get.data.loadingDevice = false;

                    if (x.status == true) {

                        get.data.DeviceList = x.data;

                        // mainData.data = x.data;
                        // theGet.data.Total = x.pesan;

                    } else {
                        get.data.DeviceList = [];
                        
                    }
                })
            }
        }
        const met = {
            back() {
                window.history.back();
            },
        }

        const redirectx = {
            checkApp() {
                myGlobal.checkApp();
            },
            now() {
                location.href="#/";
            }
        }

        return {
            met,
            get,
            redirectx
        }

    },
    mounted () {        
        this.redirectx.checkApp();

        this.get.getInfo();
    }
}
</script>

<style scoped>
.popup-box {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5);
}
.popup-inner {
    position: fixed;
    bottom: 10px;
    right: 10px;
    left: 10px;
    background-color: #fff;
    border-radius: 10px;
    padding: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/User/Modem/main.vue